module.exports = __webpack_public_path__ + "img/icon_sb_unselect_star_shopper_t.c03df84.svg";